import Box from '@mui/material/Box';

import { useDataProviderState } from '../../providers/DataProvider';
import { formVariants } from '../../constants/form';

export default function ProgressBar() {

    const { initialData, currentFormStepIndex, currentFormVariant } = useDataProviderState();
    const total = Object.keys(formVariants[currentFormVariant]).length;

    if (!initialData) return null;

    const width = `${(100 / total * (currentFormStepIndex + 1))}%`;

    return (
        <Box sx={{ marginLeft: { xs: '20px', md: '50px' }, width: '100%', paddingTop: '78px' }}>
            <Box sx={{ width: '100%', background: 'white', height: '8px', borderRadius: '10px', overflow: 'hidden' }}>
                <Box sx={{ width, background: '#09a7e0', height: '8px' }}></Box>
            </Box>
        </Box>
    );
}
